import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

import enUS from '~/app/i18n/en-US.json';

import { DEFAULT_LANGUAGE } from '../constants/i18n';

export const tolgee = Tolgee()
    .use(
        BackendFetch({
            prefix: 'https://cdn.tolg.ee/4eb8841fff5f3a980d56852345224c59',
        }),
    )
    .use(DevTools())
    .use(FormatIcu())
    .init({
        defaultLanguage:
            (typeof window !== 'undefined' && localStorage.getItem('currentLanguage')) ||
            DEFAULT_LANGUAGE,
        fallbackLanguage: DEFAULT_LANGUAGE,
        staticData: {
            'en-US': enUS,
        },
        apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
        apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
    });
